<template>
    <div class="container-fluid"><component :is="currentHome"></component></div>
</template>

<script>
import HomeDesktop from './HomeDesktop.vue';
import HomeMobile from './HomeMobile.vue';    

    export default {
        name: "NewHome",
        components: {
            HomeDesktop, HomeMobile
        },
        created() {
            // determine whether mobile or desktop by screen width
            this.currentHome = this.$root.isMobile() ? 'HomeMobile' : 'HomeDesktop';
        },
        data() {
            return {
                currentHome : 'HomeDesktop',
            };
        },
        methods: {

        }
    };

</script>